// extracted by mini-css-extract-plugin
export default {"participantsTable":"UOFEM5RURsV1omqkLm7W"};